import type { SparkleLinkProps } from "@dust-tt/sparkle";
import { forwardRef } from "react";
import { Link } from "react-router-dom";

// Link wrapper that uses React Router's Link for SPA navigation
export const ReactRouterLinkWrapper = forwardRef<
  HTMLAnchorElement,
  SparkleLinkProps
>(function ReactRouterLinkWrapper(
  { href, children, shallow: _shallow, replace, prefetch: _prefetch, ...props },
  ref
) {
  // Convert Next.js-style UrlObject into a browser-compatible URL.
  const hrefString = typeof href === "string"
    ? href
    : (() => {
        const pathname = href.pathname ?? "/";
        const params = new URLSearchParams();

        if (href.query) {
          for (const [key, value] of Object.entries(href.query)) {
            if (value === undefined || value === null) continue;
            if (Array.isArray(value)) {
              for (const item of value) params.append(key, String(item));
            } else {
              params.append(key, String(value));
            }
          }
        }

        const query = params.toString();
        const hash = href.hash
          ? href.hash.startsWith("#") ? href.hash : `#${href.hash}`
          : "";

        return `${pathname}${query ? `?${query}` : ""}${hash}`;
      })();

  // For external links or API routes, use regular anchor
  if (
    hrefString.startsWith("http://") ||
    hrefString.startsWith("https://") ||
    hrefString.startsWith("/api/")
  ) {
    return (
      <a ref={ref} href={hrefString} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link ref={ref} to={hrefString} replace={replace} {...props}>
      {children}
    </Link>
  );
});
